// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1CalR","sendOtp":"AuthorizeToLogin_sendOtp__3DREd"};